import { firestore } from "utils/firebase";

export const getReported = async (setReported, userData) => {
	const querySnapshot = await firestore
		.collection("reportedUsers")
		.get()
		.catch((error) => {
			console.error("Error getting documents: ", error);
		});

	const reported = [];

	querySnapshot.forEach((doc) => {
		const report = doc.data();
		const reportedUserData = userData.find((x) => report.reportedUser === x.id);
		const reporterData = userData.find((x) => report.userId === x.id);

		// Create placeholder for missing users instead of discarding the report
		const reportedUser = reportedUserData || {
			id: report.reportedUser ?? null,
			firstName: "Deleted user",
			lastName: "",
			deleted: true,
			defaultPic: null,
		};

		const user = reporterData || {
			id: report.userId ?? null,
			firstName: "Deleted user",
			lastName: "",
			deleted: true,
			defaultPic: null,
		};

		// Flag self-reports
		const isSelfReport =
			report.reportedUser === report.userId && !!report.reportedUser;

		reported.push({
			...doc.data(),
			id: doc.id,
			reportedUser,
			user,
			isSelfReport,
		});
	});

	setReported(reported);
};

export const resolveReport = async (report, resolved) => {
	await firestore
		.collection("reportedUsers")
		.doc(report.id)
		.update({ resolved });
};
